export default "__VITE_ASSET__0HSmZ753__"